export enum IconCardImageLocation {
  LEFT,
  CENTER,
  RIGHT,
}
